import type { FilterValidSuggestions } from "./DefectSuggestion.type";

// Function that filter defects suggestions that are not suggested or
// that are not available to the user (not listed in defect combo box).
// Note that if the suggested defect is valid, its displayed name is also appended
// (so the displayed suggested defect's text matches the one in the combo box).
// Returns a list of valid suggestions.
export const filterValidSuggestions: FilterValidSuggestions = (
  suggestions,
  visibleDefects
) => {
  const validSuggestions: {
    defect: string;
    suggested: boolean;
    confidence: number;
    name?: string;
  }[] = [];
  suggestions.forEach((suggestion) => {
    if (!suggestion.suggested) {
      return;
    }

    const defect = visibleDefects.find(
      ({ value }) => value === suggestion.defect
    );

    if (defect) {
      suggestion.name = defect.label ?? "";
      validSuggestions.push(suggestion);
    }
  });

  // Order the defects array by confidence in descending order
  return validSuggestions.sort((a, b) => b.confidence - a.confidence);
};
